export const NVM_PRODUCTION_ORIGIN = "https://cloud.nevermind.website";
export const NVM_LOCAL_ORIGIN = "http://localhost:8787";

const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);

export function isLocalHostname(hostname: string): boolean {
	return LOCAL_HOSTNAMES.has(hostname);
}
